import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { DatePipe } from '@angular/common';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatText, formatYear } from 'src/app/shared/commen-function-file';
import * as echarts from 'echarts';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { DwmdashboardpopupComponent } from '../dwmdashboardpopup/dwmdashboardpopup.component';
import { DwmrepositorypopupComponent } from '../dwmrepositorypopup/dwmrepositorypopup.component';
import { formatYearRanges } from 'src/app/shared/commen-function-file';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { DwmGenericServiceService } from '../../_DWM-Generic-Services/generic-service.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { forkJoin } from 'rxjs';
import { DwmaudittrailhrComponent } from '../dwmaudittrailhr/dwmaudittrailhr.component';

@Component({
  selector: 'app-dwmdashboard',
  templateUrl: './dwmdashboard.component.html',
  styleUrls: ['./dwmdashboard.component.scss']
})
export class DwmdashboardComponent implements OnInit {
  buttonColorName: string | null = null;
  subModuleButtonColor: string | null = null;
  loggedInUserCompanyID: number | null = null;
  loggedInCompanyFiscalyear: any | null = null;
  loggedInUserEmpCode: string | null = null;
  intHODempCode: string | null = null;
  loggedInUserId: string | null = null;
  loggedInUserRole: any | null = null;
  loggedInUserRoles: any[] = [];
  loggedInUserRoleIsEmployee = false;
  loggedInCompanyMDCode: string | null = null;
  isCurrentYearSelected: boolean = false;
  currentPageNumber: any = 1;
  pmsYears: any = [];
  selectedYear: any;
  fromYear: string = '';
  isRNDEmployee = false;
  loggedInUserName: any;
  loggedInCompanyReviewCycle: any | null;
  selectedDepartment: string | null = null;
  selectedGrade: string | null = null;
  selectedFilters: any = {
    selectedEmpId: null,
    selectedYear: null,
    selectedMonth: null,
    selectedDwmType: 'Monthly',
    searchString: null,
    selectedDepartment: null,
    selectedGrade: null,
    isCutoffTaskEditable: null
  };

  toYear: string = '';
  selectedMonthForDWM: string = '';
  selectedYearForDWM: any = null;
  filteredDashboardCounters: any[] = [];
  effectiveRole: string | undefined;
  formatedataVariable = formatText;
  selectedGraphYearForProduct: any = null;
  selectedGraphMonthForProduct: string = '';
  selectedGraphYearForCritical: any = null;
  selectedGraphYearForPlantLocation: any = null;
  selectedGraphYearForIncomplete: any = null;
  selectedGraphMonthForIncomplete: string = '';
  selectedGraphMonthForCritical: string = '';
  selectedGraphMonthForPlantLocation: string = '';
  selectedGraphYearForCompliance: any = null;
  selectedGraphMonthForCompliance: string = '';

  isTeamView = false; // false = SELF, true = TEAM

  // --------------- Months List -----------------

  filteredMonthsList: string[] = [];

  monthsList: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  dashboardCounters = [
    {
      counterIcon: 'assets/svg/dwm-submitted.svg',
      counterName: 'DWM Submitted',
      totalCount: '' as any,
      percentage: null,
      color: '#3067FA',
      background: '#D4DBEB',
      allowedRoles: ['HR Admin', 'Super Admin', 'Admin']
    },
    {
      counterIcon: 'assets/svg/dwm-approved.svg',
      counterName: 'DWM Approved',
      totalCount: '' as any,
      percentage: '' as any,
      color: '#F3820E',
      background: '#FFE3C3',
      allowedRoles: ['HR Admin', 'Super Admin', 'Admin']
    },
    {
      counterIcon: 'assets/svg/dwm-total-rnd-hours-logged.svg',
      counterName: 'Total R&D Hours Logged',
      totalCount: 0,
      color: '#33B060',
      background: '#D5EBDD',
      allowedRoles: ['HR Admin', 'Super Admin', 'Admin']
    },
    {
      counterIcon: 'assets/svg/dwm-avg-compliance-score.svg',
      counterName: 'Avg Compliance Score',
      totalCount: 0,
      color: '#2D82D7',
      background: '#CEDEEE',
      allowedRoles: ['HR Admin', 'Super Admin', 'Admin', 'Manager', 'Employee', 'HOD']
    },
    {
      counterIcon: 'assets/svg/dwm-task-sent.svg',
      counterName: 'Count of Task Sent',
      totalCount: 0,
      color: '#E94848',
      background: '#F2DEDE',
      allowedRoles: ['Manager', 'Employee', 'HOD']
    },
    {
      counterIcon: 'assets/svg/dwm-approved.svg',
      counterName: 'Count of Task Approved',
      totalCount: 0,
      color: '#393186',
      background: '#DCDBEB',
      allowedRoles: ['Manager', 'Employee', 'HOD']
    },
    {
      counterIcon: 'assets/svg/dwm-total-duration-worked.svg',
      counterName: 'Total Duration Worked(R&D)',
      totalCount: '00:00',
      color: '#982F2F',
      background: '#EECBCB'
    },
    {
      counterIcon: 'assets/svg/dwm-done-on-time.svg',
      counterName: 'Done on Time',
      totalCount: 0,
      color: '#33B060',
      background: '#D5EBDD',
      allowedRoles: ['Manager', 'Employee', 'HOD']
    },
    {
      counterIcon: 'assets/svg/dwm-done-with-delay.svg',
      counterName: 'Done with Delay',
      totalCount: 0,
      color: '#F3820E',
      background: '#FFE3C3',
      allowedRoles: ['Manager', 'Employee', 'HOD']
    },
    {
      counterIcon: 'assets/svg/dwm-incomplete-after-due.svg',
      counterName: 'Incomplete After Due Date',
      totalCount: 0,
      color: '#E94848',
      background: '#F2DEDE',
      allowedRoles: ['Manager', 'Employee', 'HOD']
    },
    {
      counterIcon: 'assets/svg/dwm-not-started.svg',
      counterName: 'Not Completed',
      totalCount: 0,
      color: '#6B7280',
      background: '#E5E7EB',
      allowedRoles: ['Manager', 'Employee', 'HOD']
    }
  ];

  userIsAdminTypes: any = null;
  allEmpIdsForAdmin: string[] = [];
  dwmAdminData: any;
  dwmUsers: any = null;
  multiDropdownSettings = {
    singleSelection: false,
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  constructor(
    private fb: FormBuilder,
    public mobileResponsiveService: MobileResponsiveService,
    private httpService: HttpService,
    private config: Config,
    private encryptionService: EncryptionService,
    private dataRefreshService: DataRefreshService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public sharedService: SharedService,
    private PdfDownload: PdfDownloadService,
    private router: Router,
    private getCompanyAndUserData: GetCompanyAndUsersData,
    public dwmGenericServiceService: DwmGenericServiceService,
    public genericService: GenericService
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }

    this.userIsAdminTypes = this.dwmGenericServiceService.checkIsLoggedInUserIsAdmin();
    if (this.userIsAdminTypes?.userIsAdmin) {
      const request = { companyId: this.loggedInUserCompanyID, search: null, loggedInUserRole: 'Admin' };
      this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request).subscribe({
        next: (data: any) => {
          if (data?.status) {
            this.dwmAdminData = data?.data?.access[0] || [];
            // console.log(this.dwmAdminData?.employeeDetails);
            this.dwmAdminData?.employeeDetails.map((ids: any) => {
              this.allEmpIdsForAdmin.push(String(ids?.employeeId));
            });
            setTimeout(() => {
              this.getCountersForAdmin(this.allEmpIdsForAdmin);
            }, 250);
            this.getDepartments();
          }
        }
      });
    } else {
      this.getDepartments();
    }

    if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') {
      this.isTeamView = true;
    } else {
      this.isTeamView = false;
    }

    this.getpmsyearlist();
    this.getEmployeeList();
    setTimeout(() => {
      this.refreshDashboardGraphs();
    }, 1000);
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  // --------------- Set Selected Year -----------------

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;
      this.selectedGraphYear = this.selectedYearForDWM;
      this.selectedGraphMonth = this.selectedMonthForDWM;
      this.selectedGraphYearForProduct = this.selectedYearForDWM;
      this.selectedGraphMonthForProduct = this.selectedMonthForDWM;
      this.selectedGraphYearForCritical = this.selectedYearForDWM;
      this.selectedGraphYearForPlantLocation = this.selectedYearForDWM;
      this.selectedGraphMonthForCritical = this.selectedMonthForDWM;
      this.selectedGraphMonthForPlantLocation = this.selectedMonthForDWM;
      this.selectedGraphYearForIncomplete = this.selectedYearForDWM;
      this.selectedGraphMonthForIncomplete = this.selectedMonthForDWM;
      this.selectedGraphYearForCompliance = this.selectedYearForDWM;
      this.selectedGraphMonthForCompliance = this.selectedMonthForDWM;
      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.getYearSetupForDWM(this.selectedYearForDWM);

      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  selectYearSetup(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    this.getYearSetupForDWM(this.selectedYearForDWM);
  }

  // --------------- Get Year Setup For DWM -----------------
  isYearChanging = false;
  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.isYearChanging = true;

    this.selectedPlantsForDashbaordCounter = [];
    this.selectedPlants = [];


    this.selectedGraphYear = this.selectedGraphYearForCompliance = this.selectedGraphYearForCritical = this.selectedGraphYearForPlantLocation = this.selectedGraphYearForIncomplete = this.selectedGraphYearForProduct = this.selectedYearForDWM;

    this.selectedYear = year;

    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    // console.log("Company Fiscal Year..", this.loggedInCompanyFiscalyear)
    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;
    // console.log("Current Fiscal Year...", currentFiscalYear)
    this.isCurrentYearSelected = year === currentFiscalYear;
    // IF CURRENT YEAR → AUTO SELECT ALL PLANTS
    if (this.isCurrentYearSelected) {
      setTimeout(() => {
        this.selectedPlantsForDashbaordCounter = [...this.plantList];
        this.selectedPlants = [...this.plantList];

        this.getDashboardForHr();
        this.getDashboardGraphForPlantLocationWiseTaskStatus();
      }, 300);
    }
    this.getPlantsLocation();
    this.filterMonthsByFiscalYear(year);

    this.getDashboardGraphTaskStatus();
    this.getDashboardIncompleteTask();
    this.getBarChartForProductTimeForRnDUser();
    this.getDashboardForCriticalTask();
    this.getDashboardForComplianceScore();

    this.currentPageNumber = 1;
    this.applyDataFilters('', '', false);
  }



  // getDwmYear(): number {

  //   const selectedYearObj = this.pmsYears.find(
  //     (y: { year: any; }) => y.year === this.selectedGraphYearForPlantLocation
  //   );

  //   if (!selectedYearObj || !this.selectedGraphMonthForPlantLocation) {
  //     return new Date().getFullYear();
  //   }

  //   const [startYear, endYear] = selectedYearObj.year.split('-').map(Number);

  //   const monthNumber =
  //     this.monthsList.indexOf(this.selectedGraphMonthForPlantLocation) + 1;

  //   return monthNumber >= 4 ? startYear : endYear;
  // }
  // getDwmYear(): number {
  //   if (!this.selectedMonthForDWM || !this.filteredMonthsList?.length) {
  //     return Number(this.selectedYearForDWM.split('-')[0]);
  //   }

  //   const [startYear, endYear] = this.selectedYearForDWM.split('-').map(Number);
  //   const fiscalStartMonth = this.filteredMonthsList[0];

  //   return this.monthsList.indexOf(this.selectedMonthForDWM) < this.monthsList.indexOf(fiscalStartMonth) ? endYear : startYear;
  // }

  // --

  getDwmYear(selectedYear: string, selectedMonth: string): number {

    if (!selectedYear || !selectedMonth) {
      return new Date().getFullYear();
    }

    const [startYear, endYear] = selectedYear.split('-').map(Number);

    const monthNumber = this.monthsList.indexOf(selectedMonth) + 1;

    return monthNumber >= 4 ? startYear : endYear;
  }

  isCardDisabled(item: any): boolean {
    const restrictedCounters = ['Count of Task Sent', 'Count of Task Approved', 'Total Duration Worked(R&D)', 'Avg Compliance Score', 'Done on Time', 'Done with Delay', 'Incomplete After Due Date', 'Not Completed'];

    // 🔹 EXISTING LOGIC – DO NOT CHANGE
    const existingCondition = (this.loggedInUserRole === 'Employee' || (!this.isTeamView && item.counterName !== 'Avg Compliance Score')) && restrictedCounters.includes(item.counterName);

    // 🔹 ADDITIONAL ROLE-WISE CONDITION (ONLY FOR HOD / MANAGER)
    const hodManagerSelfAvgComplianceDisabled = (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') && !this.isTeamView && item.counterName === 'Avg Compliance Score';

    return existingCondition || hodManagerSelfAvgComplianceDisabled;
  }

  getEmployeeList() {
    this.getCompanyAndUserData.getAllEmployeeByCompanyID().subscribe((res: any) => {
      const empList = res?.data || [];
      const loggedInEmpId = this.loggedInUserId;
      const loggedInEmployee = empList.find((emp: any) => emp.id === loggedInEmpId);
      /* ---------------- R&D Role ---------------- */
      this.isRNDEmployee = loggedInEmployee?.department === 'R&D';
      // console.log('Is R&D Employee:', this.isRNDEmployee);
      this.applyDashboardCounterFilter();
      // console.log('L4 And Above Employee:', this.isL4AndAboveEmployee);
    });
  }

  applyDashboardCounterFilter() {
    this.filteredDashboardCounters = this.dashboardCounters.filter(counter => {
      // console.log('Filter dahsboard counter for manager...', this.filteredDashboardCounters);
      // ----- Total Duration Worked (R&D + Role based) -----
      // if (counter.counterName === 'Total Duration Worked') {
      //   return this.isRNDEmployee === true && ['Employee', 'Manager', 'HOD'].includes(this.loggedInUserRole);
      // }

      if (counter.counterName === 'Total Duration Worked(R&D)') {
        // Condition-1 (KEEP AS IS): R&D Employee
        if ((this.isRNDEmployee === true && this.loggedInUserRole === 'Employee') || this.loggedInUserRole === 'HOD' || this.loggedInUserRole === 'Manager') {
          return true;
        }

        // Condition-2 (NEW): Manager / HOD (Team)
        if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') {
          return true;
        }

        return false;
      }

      // ----- Normal role-based counters -----
      if (!counter.allowedRoles) return true;

      return counter.allowedRoles.includes(this.loggedInUserRole);
    });

    // console.log('Filtered Dashboard Counters:', this.filteredDashboardCounters);
  }

  // ------------------------------- Get Employee Under the Manager --------------------------
  dailyTeamTaskFromDate = new Date();
  getIndirectEmployees: any = [];

  getTeamOfManager() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      date: null,
      from: this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      fromYear: null,
      to: this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      toYear: null,
      userId: this.loggedInUserId,
      userType: null,
      yearRange: null
    };

    this.httpService.callPostService(this.config.getTeamOfManagerForDWm, request).subscribe((data: any) => {
      this.getIndirectEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          name: ele?.firstName + ' ' + ele?.lastName,
          id: ele?.id
        };
        this.getIndirectEmployees.push(obj);
      });
      this.getIndirectEmployees = this.getIndirectEmployees?.sort((a: any, b: any) => a.name.localeCompare(b.name));
      // console.log('Team Employees....', this.getIndirectEmployees);
    });
  }

  //  ------------------------------- On Month Change Dashboard --------------------------
  //   onMonthChangeDashboard() {

  //     this.selectedGraphMonth = this.selectedGraphMonthForCompliance = this.selectedGraphMonthForPlantLocation = this.selectedGraphMonthForCritical = this.selectedGraphMonthForIncomplete = this.selectedGraphMonthForProduct = this.selectedMonthForDWM;

  // const currentMonth = new Date().toLocaleString('default', { month: 'long' });

  // if (this.selectedMonthForDWM === currentMonth) {
  //   this.selectedPlantsForDashbaordCounter = [...this.plantList];
  //   this.selectedPlants = [...this.plantList];

  //   this.getDashboardForHr();
  //   this.getDashboardGraphForPlantLocationWiseTaskStatus();
  //   return; // stop further reset logic
  // }

  //     this.selectedPlantsForDashbaordCounter = [];
  //     this.onPlantDeSelectAllForCounter();
  //     // HR / Super Admin
  //     if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin') {
  //       this.getDashboardForHr();
  //       return;
  //     }
  //     if (this.userIsAdminTypes?.userIsAdmin) {
  //       this.applyDataFilters('', '', false);
  //       return;
  //     }

  //     // Employee / Manager / HOD
  //     this.getDashboardForEmployeeManager();


  //     setTimeout(() => {
  //       this.getDashboardGraphForPlantLocationWiseTaskStatus();
  //       this.getDashboardGraphTaskStatus();
  //       this.getDashboardIncompleteTask();
  //       this.getDashboardForCriticalTask();
  //       this.getDashboardForComplianceScore();
  //       this.getBarChartForProductTimeForRnDUser();
  //     }, 500);
  //   }


  onMonthChangeDashboard() {
    // ✅ Sync ALL graph month variables first
    this.selectedGraphMonth =
      this.selectedGraphMonthForCompliance =
      this.selectedGraphMonthForPlantLocation =
      this.selectedGraphMonthForCritical =
      this.selectedGraphMonthForIncomplete =
      this.selectedGraphMonthForProduct =
      this.selectedMonthForDWM;

    const currentMonth = new Date().toLocaleString('default', { month: 'long' });

    if (this.selectedMonthForDWM === currentMonth) {
      this.selectedPlantsForDashbaordCounter = [...this.plantList];
      this.selectedPlants = [...this.plantList];
      this.getDashboardForHr();
      this.getDashboardGraphForPlantLocationWiseTaskStatus();

      this.getDashboardForEmployeeManager();
      setTimeout(() => {
        this.getDashboardGraphTaskStatus();
        this.getDashboardIncompleteTask();
        this.getDashboardForCriticalTask();
        this.getDashboardForComplianceScore();
        this.getBarChartForProductTimeForRnDUser();
      }, 500);
      return;
    }

    this.selectedPlantsForDashbaordCounter = [];
    this.onPlantDeSelectAllForCounter();

    // HR / Super Admin
    if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin') {
      this.getDashboardForHr();

      setTimeout(() => {
        this.getDashboardGraphForPlantLocationWiseTaskStatus();
      }, 500);
      return;
    }

    if (this.userIsAdminTypes?.userIsAdmin) {
      this.applyDataFilters('', '', false);
      return;
    }

    // Employee / Manager / HOD
    this.getDashboardForEmployeeManager();

    setTimeout(() => {
      this.getDashboardGraphForPlantLocationWiseTaskStatus();
      this.getDashboardGraphTaskStatus();
      this.getDashboardIncompleteTask();
      this.getDashboardForCriticalTask();
      this.getDashboardForComplianceScore();
      this.getBarChartForProductTimeForRnDUser();
    }, 500);
  }
  // On toggle change for SELF / TEAM view

  onTeamToggleChange(isChecked: boolean) {
    this.isTeamView = isChecked;
    this.getDashboardForEmployeeManager();
    setTimeout(() => {
      this.refreshDashboardGraphs();
    });
  }

  refreshDashboardGraphs() {
    this.getDashboardGraphTaskStatus();
    this.getDashboardForComplianceScore();
    this.getDashboardIncompleteTask();
    this.getDashboardForCriticalTask();
    this.getBarChartForProductTimeForRnDUser();
  }

  filterMonthsByFiscalYear(selectedYear: string) {
    const fiscal = this.loggedInCompanyFiscalyear;
    const [startMon, endMon] = fiscal.split('_');

    const monthIndex = (mon: string) => new Date(`${mon} 1, 2000`).getMonth();

    const startIdx = monthIndex(startMon);
    const endIdx = monthIndex(endMon);

    this.filteredMonthsList = startIdx <= endIdx ? this.monthsList.slice(startIdx, endIdx + 1) : [...this.monthsList.slice(startIdx), ...this.monthsList.slice(0, endIdx + 1)];
    const currentMonth = new Date().toLocaleString('default', {
      month: 'long'
    });

    this.selectedMonthForDWM = this.isCurrentYearSelected && this.filteredMonthsList.includes(currentMonth) ? currentMonth : '';
    this.selectedGraphMonth = this.selectedMonthForDWM;
    this.selectedGraphMonthForProduct = this.selectedMonthForDWM;
    this.selectedGraphMonthForCritical = this.selectedMonthForDWM;
    this.selectedGraphMonthForIncomplete = this.selectedMonthForDWM;
    this.selectedGraphMonthForCompliance = this.selectedMonthForDWM;
    this.selectedGraphMonthForPlantLocation = this.selectedMonthForDWM;
    if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin') {
      setTimeout(() => {
        this.getDashboardForHr();
      }, 500);
    } else {
      setTimeout(() => {
        this.getDashboardForEmployeeManager();
      }, 500);
    }
  }

  onClickCard(event: any) {
    // if (window.innerWidth <= 800) { return; } // Uncomment this if you want to show on mobile
    // console.log('CLICKED:', event);
    const year = this.getCompanyAndUserData.getYearAsPerSelectedFinancialYearAnddMonth(this.selectedYearForDWM, this.selectedMonthForDWM);
    // const year = this.getDwmYear(); 
    console.log('SelectedYear for API Call...', this.selectedYearForDWM);
    const successdialogRef = this.dialog.open(DwmdashboardpopupComponent, {
      disableClose: true,
      // height: '30%',
      // width: this.mobileResponsiveService.modelWidthForMobileDevice,
      maxWidth: this.mobileResponsiveService.modelMaxWidth992AndBelow,
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh', 'mx-h60vh'],
      data: {
        counterName: event,
        year: this.selectedYearForDWM,
        plantLocations: this.selectedPlantsForDashbaordCounter.map((p: any) => p.id || p),
        month: this.selectedMonthForDWM,
        empDetails: this.selectedFilters?.selectedEmpId
          ? {
            userIds: [this.selectedFilters.selectedEmpId],
            companyId: this.loggedInUserCompanyID,
            year: String(year),
            month: this.genericService.getCurrentMonthInNumber(this.selectedMonthForDWM)

          }
          : null
      }
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }

  checkIfPreviousMonthSelected() {
    const currentMonthIndex = new Date().getMonth();
    const selectedIndex = this.monthsList.indexOf(this.selectedMonthForDWM);
    const prevMonthIndex = currentMonthIndex === 0 ? 11 : currentMonthIndex - 1;
    this.currentPageNumber = 1;
  }

  // ------------------------------------------------- Filter Dashboards Data -------------------------------------
  filterDashboardsData(empId: number) {
    // console.log('Filters applied:', this.selectedFilters);
    this.selectedFilters.selectedEmpId = empId;
    this.getDashboardForHr();
    this.currentPageNumber = 1;
  }
  // ------------------------------------------------ Get Departments  -------------------------------------
  departmentsList: any[] = [];
  getDepartments() {
    this.httpService.callGetService(`${this.config.getDwmDepartmentsByCompany}/${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      this.departmentsList = res?.data || [];
      if (this.userIsAdminTypes?.userIsAdmin) this.departmentsList = this.departmentsList.filter((department: any) => this.dwmAdminData?.department.includes(department));
    });
  }

  myTaskStatusGraphKey = 0;

  // ------------------------------------------ On DepartmentChange Get  Grades --------------------------------------------------

  gradesList: any[] = [];
  getGrades(selectedDepartment: any) {
    this.selectedFilters.selectedEmpId = null;
    this.employeesList = [];
    if (selectedDepartment?.length) {
      this.httpService
        .callPostService(this.config.getDwmGradesByDepartment, {
          companyId: this.loggedInUserCompanyID,
          department: selectedDepartment
        })
        .subscribe((res: any) => {
          this.selectedFilters.selectedGrade = null;
          this.gradesList = res?.data || [];
          if (this.userIsAdminTypes?.userIsAdmin) this.gradesList = this.gradesList.filter((gradesList: any) => this.dwmAdminData?.band.includes(gradesList));
        });
    } else {
      this.selectedFilters.selectedGrade = null;
      this.gradesList = [];
    }
  }

  // ------------------------------------- On grade change get employees ----------------------------------
  employeesList: any[] = [];
  onGradeChange(selectedGrade: string) {
    // console.log('Selected Grade:', grade);
    if (!this.selectedFilters?.selectedDepartment || !this.selectedFilters?.selectedGrade) return;

    this.selectedFilters.selectedEmpId = null;
    this.employeesList = [];

    if (!selectedGrade?.length) return;

    const payload = {
      companyId: this.loggedInUserCompanyID,
      department: this.selectedFilters.selectedDepartment,
      grades: selectedGrade
    };

    // console.log('Employee Payload:', payload);

    this.httpService.callPostService(this.config.getDwmUserListByGrade, payload).subscribe((res: any) => {
      // console.log('Employees response:', res);
      const empList = res?.data || [];
      if (this.userIsAdminTypes?.userIsAdmin) {
        // console.log('this.dwmAdminData.employeeDetails - ', this.dwmAdminData.employeeDetails, empList);
        this.employeesList = empList.filter((emp: any) => this.dwmAdminData.employeeDetails.some((empAdmin: any) => +emp.id === +empAdmin.employeeId));
      } else {
        this.employeesList = empList;
      }
    });
  }

  // --------------------------------- Get Dahsboard counters ---------------------------------------------
  selectedPlantsForDashbaordCounter: string[] = [];
  getDashboardForHr() {
    if (!this.selectedPlantsForDashbaordCounter?.length) {
      this.resetDashboardCounters();
      return;
    }

    if (!this.selectedYearForDWM || !this.selectedMonthForDWM) {
      this.resetDashboardCounters();
      return;
    }

    const [startYear, endYear] = this.selectedYearForDWM.split('-').map(Number);

    const fiscalStartMonth = this.filteredMonthsList[0];
    const monthIndex = this.monthsList.indexOf(this.selectedMonthForDWM);

    const year = monthIndex < this.monthsList.indexOf(fiscalStartMonth) ? endYear : startYear;

    const payload = {
      companyId: this.loggedInUserCompanyID,
      year: year,
      month: monthIndex + 1,
      plantLocations: this.selectedPlantsForDashbaordCounter.map((p: any) => p.id || p)
    };

    // console.log('Payload:', payload);

    this.httpService.callPostService(this.config.getHrAdminDashboardCOunt, payload).subscribe((res: any) => {
      // console.log('Response:', res);

      const data = res?.data;
      if (!data) return;

      this.filteredDashboardCounters.forEach(counter => {
        switch (counter.counterName) {
          case 'DWM Submitted':
            counter.totalCount = `${data.employeePendingStatusCount} / ${data.totalEmployeeCount}`;
            counter.percentage = data.hrSubmittedPercentage?.toFixed(2);
            break;

          case 'DWM Approved': {
            const submitted = data.employeePendingStatusCount || 0;
            const approved = data.noOfApprovedTaskEmployee || 0;

            counter.totalCount = `${approved} / ${submitted}`;
            counter.percentage = submitted ? ((approved / submitted) * 100).toFixed(2) : '0.00';
            break;
          }

          case 'Total R&D Hours Logged':
            counter.totalCount = data.hrRnDTotalDurationCount;
            break;

          case 'Avg Compliance Score':
            if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin') {
              counter.totalCount = data.hrAverageComplianceScore?.toFixed(2) || '0.00';
            }
            break;
        }
      });
    });
  }


  resetDashboardCounters() {
    this.filteredDashboardCounters.forEach(counter => {
      counter.totalCount = 0;
      counter.percentage = null;
    });
  }

  onPlantSelectForCounter() {
    this.getDashboardForHr();
    this.selectedPlants = [...this.selectedPlantsForDashbaordCounter];
    setTimeout(() => {
      this.getDashboardGraphForPlantLocationWiseTaskStatus();
    }, 500);
  }


  onPlantDeselectForCounter() {
    this.getDashboardForHr();
    this.selectedPlants = [...this.selectedPlantsForDashbaordCounter];
    this.getDashboardGraphForPlantLocationWiseTaskStatus();
  }

  onPlantSelectAllForCounter(items: any[]) {
    this.selectedPlantsForDashbaordCounter = items;
    this.selectedPlants = [...items];
    this.getDashboardForHr();
    this.getDashboardGraphForPlantLocationWiseTaskStatus();
  }

  onPlantDeSelectAllForCounter() {
    this.selectedPlantsForDashbaordCounter = [];
    this.selectedPlants = [];

    this.getDashboardForHr();
    this.getDashboardGraphForPlantLocationWiseTaskStatus();
  }


  getDashboardForEmployeeManager() {
    if (!this.selectedYearForDWM || !this.selectedMonthForDWM) return;

    const [startYear, endYear] = this.selectedYearForDWM.split('-').map(Number);
    const fiscalStartMonth = this.filteredMonthsList[0];
    const monthIndex = this.monthsList.indexOf(this.selectedMonthForDWM);

    const year = monthIndex < this.monthsList.indexOf(fiscalStartMonth) ? endYear : startYear;

    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: year,
      month: monthIndex + 1
    };

    // ---------------- ROLE BASED PAYLOAD ----------------

    // Employee login → always self
    if (this.loggedInUserRole === 'Employee') {
      payload.userId = Number(this.loggedInUserId);
    }

    // Manager / HOD
    if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') {
      if (this.isTeamView) {
        // TEAM VIEW → only managerId
        payload.managerId = Number(this.loggedInUserId);
      } else {
        // SELF VIEW → only userId
        payload.userId = Number(this.loggedInUserId);
      }
    }
    // console.log('Payload:', payload);

    this.httpService.callPostService(this.config.getEmpManagerDashboardCOunt, payload).subscribe((res: any) => {
      const data = res?.data;
      if (!data) return;

      this.filteredDashboardCounters.forEach(counter => {
        switch (counter.counterName) {
          case 'Count of Task Sent':
            counter.totalCount = data.employeeSentTaskCount || 0;
            break;

          case 'Count of Task Approved':
            counter.totalCount = data.employeeApprovedTaskCount || 0;
            break;

          case 'Done on Time':
            counter.totalCount = data.taskCompletionBreakdown?.doneOnTime || 0;
            break;

          case 'Done with Delay':
            counter.totalCount = data.taskCompletionBreakdown?.doneWithDelay || 0;
            break;

          case 'Incomplete After Due Date':
            counter.totalCount = data.taskCompletionBreakdown?.incompleteAfterDueDate || 0;
            break;

          case 'Not Completed':
            counter.totalCount = data.taskCompletionBreakdown?.notStarted || 0;
            break;
          case 'Avg Compliance Score':
            if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'Employee' || this.loggedInUserRole === 'HOD') {
              counter.totalCount = data.averageCompliancePercentage?.toFixed(2) || '0.00';
              // console.log('Manager compliance score...', data.averageCompliancePercentage);
              counter.percentage = null;
            }
            break;
          case 'Total Duration Worked(R&D)':
            // counter.totalCount = this.isRNDEmployee ? data.calculateTotalRnDDuration || '00:00' : '00:00';
            counter.totalCount = data.calculateTotalRnDDuration || '00:00';
            break;
        }
      });

      // console.log('Updated Dashboard Counters:', this.dashboardCounters);
    });
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object';
  }

  // ====================================================== DWM Repository ====================================

  dwmRepositoryPopup() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '70%';
    dialogConfig.data = {
      btn2: 'OK',
      moduleName: event,
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(DwmrepositorypopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(_result => { });
  }

  // ================================================== Dashboard graphs =========================================================================
  // ------------------------------------- Task Status Pie Chart --------------------------------------------
  onGraphYearChange(year: any) {
    this.selectedGraphYear = year;

    // RESET DATA FIRST
    this.empTaskStatusPieData = [];
    this.teamTaskStatusRows = [];

    // decide month
    if (year === this.selectedYearForDWM) {
      this.selectedGraphMonth = this.selectedMonthForDWM;
    } else {
      this.selectedGraphMonth = ''; // or null
    }

    // IMPORTANT: call API ONLY if valid month exists
    if (this.selectedGraphMonth) {
      this.getDashboardGraphTaskStatus();
    } else {
      this.clearTaskStatusChart(); // show empty state
    }
  }


  onMonthChangeGraph(month: any) {
    this.selectedGraphMonth = month;
    this.getDashboardGraphTaskStatus();
  }


  selectedGraphYear: any = null;
  selectedGraphMonth: string = '';
  empTaskStatusPieData: any[] = [];
  empTaskStatusChart: echarts.ECharts | null = null; // SELF
  teamTaskStatusRows: any[] = []; // TEAM
  teamTaskStatusChart: any;

  getDashboardGraphTaskStatus() {
    if (!this.selectedGraphYear || !this.selectedGraphMonth) return;

    const monthNumber = this.monthsList.indexOf(this.selectedGraphMonth) + 1;

    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(this.selectedGraphYear, this.selectedGraphMonth),
      month: monthNumber
    };

    //  SAME toggle used for counters
    if (this.isTeamView) {
      payload.managerId = this.loggedInUserId;
    } else {
      payload.userId = this.loggedInUserId;
    }

    this.httpService.callPostService(this.config.getDwmTaskStatusGraph, payload).subscribe((res: any) => {
      const data = res?.data || [];
      if (!data.length) {
        this.clearTaskStatusChart();
        return;
      }

      if (this.isTeamView) {
        this.teamTaskStatusRows = data;
        this.renderTeamTaskStatusStackedBar();
      } else {
        const row = data[0];

        this.empTaskStatusPieData = [
          { name: 'Done on Time', value: row.doneOnTime || 0 },
          { name: 'Done with Delay', value: row.doneWithDelay || 0 },
          { name: 'Incomplete After Due Date', value: row.incompleteAfterDueDate || 0 },
          { name: 'Not Completed', value: row.notStarted || 0 }
        ];

        this.renderEmpTaskStatusPie();
      }
    });
  }

  clearTaskStatusChart() {
    const dom = document.getElementById('empTaskStatus');
    if (!dom) return;

    if (this.empTaskStatusChart) {
      this.empTaskStatusChart.clear();
    }

    if (this.teamTaskStatusChart) {
      this.teamTaskStatusChart.clear();
    }
  }

  renderTeamTaskStatusStackedBar() {
    const chartDom = document.getElementById('empTaskStatus');
    if (!chartDom) return;

    if (!this.teamTaskStatusChart) {
      this.teamTaskStatusChart = echarts.init(chartDom);
    }

    const employees = this.teamTaskStatusRows.map((e: any) => e.userName);

    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' }
      },
      legend: {
        bottom: 0
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true
      },

      xAxis: {
        type: 'category',
        data: employees,
        name: 'Employees',
        nameLocation: 'middle',
        nameGap: 30,
        axisLabel: {
          interval: 0,
          rotate: 30,
          fontSize: 10
        }
      },
      yAxis: {
        type: 'value',
        name: 'Task Count',
        nameLocation: 'middle',
        nameGap: 30,
        splitLine: { show: false }
      },
      series: [
        {
          name: 'Done on Time',
          type: 'bar',
          stack: 'total',
          emphasis: { focus: 'series' },
          itemStyle: { color: '#4CAF50' },
          data: this.teamTaskStatusRows.map((e: any) => e.doneOnTime || 0)
        },
        {
          name: 'Done with Delay',
          type: 'bar',
          stack: 'total',
          itemStyle: { color: '#FFC107' },
          data: this.teamTaskStatusRows.map((e: any) => e.doneWithDelay || 0)
        },
        {
          name: 'Incomplete After Due Date',
          type: 'bar',
          stack: 'total',
          itemStyle: { color: '#FF9800' },
          data: this.teamTaskStatusRows.map((e: any) => e.incompleteAfterDueDate || 0)
        },
        {
          name: 'Not Completed',
          type: 'bar',
          stack: 'total',
          itemStyle: { color: '#F44336' },
          data: this.teamTaskStatusRows.map((e: any) => e.notStarted || 0)
        }
      ]
    };
    setTimeout(() => {
      this.teamTaskStatusChart.setOption(option);
      this.mobileResponsiveService.chartResizeFn(this.teamTaskStatusChart);
    }, 500);
  }

  renderEmpTaskStatusPie() {
    const dom = document.getElementById('empTaskStatus');
    setTimeout(() => {
      if (!dom) return;

      if (!this.empTaskStatusChart) {
        this.empTaskStatusChart = echarts.init(dom);
      }

      const option = this.getPieChartOptionForEmpWiseTaskStatus(this.empTaskStatusPieData);

      this.empTaskStatusChart.setOption(option, true);
      this.mobileResponsiveService.chartResizeFn(this.empTaskStatusChart);
    }, 800);
  }

  getPieChartOptionForEmpWiseTaskStatus(data: any): echarts.EChartsOption {
    const allZero = data.every((item: { value: number }) => item.value === 0);

    if (allZero) {
      return {
        title: {
          text: 'No data available',
          left: 'center',
          top: 'center',
          textStyle: {
            fontSize: 20,
            color: '#999'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: 'No data available'
        },
        series: []
      };
    }

    return {
      tooltip: { trigger: 'item' },
      legend: { top: '5%', left: 'center' },
      series: [
        {
          name: 'Task Status',
          type: 'pie',
          radius: '50%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data
        }
      ],
      toolbox: {
        show: true,
        feature: { saveAsImage: { show: false } },
        iconStyle: { borderColor: '#F3820E' }
      }
    };
  }








  onPlantGraphYearChange(year: string) {
    this.selectedGraphYearForPlantLocation = year;

    //  Reset Month
    this.selectedGraphMonthForPlantLocation = '';

    // Reset Plant (optional but correct UX)
    this.resetPlantSelection();
  }

  onPlantGraphMonthChange(month: string) {
    this.selectedGraphMonthForPlantLocation = month;

    //  Reset Plant
    this.resetPlantSelection();

    //  Now call API (only when month is selected)
    // this.getPlantsLocation();
    this.getDashboardGraphForPlantLocationWiseTaskStatus();
  }


  private resetPlantSelection() {
    this.selectedPlants = [];

  }


  // ------------------------------- Download graph for Plantwuse task status --------------------------------
  downloadPlantLocationTaskStatusGraphPDF() {

    const chartElement = document.getElementById('plantTaskStatus') as HTMLDivElement;

    if (!chartElement) {
      console.error('Plant Task Status chart element not found');
      return;
    }

    // Use SAME logic like your reference
    const year = this.getDwmYear(this.selectedGraphYearForPlantLocation, this.selectedGraphMonthForPlantLocation);
    const month = this.selectedGraphMonthForPlantLocation;

    const title = `Plant Location Task Status - ${month} ${year}`;

    this.downloadGraphAsPDF(chartElement, title);
  }

  // ----------------- Download graph for My/Team Task status -----------------------------

  downloadTaskStatusGraphPDF() {
    const chartElement = document.getElementById('empTaskStatus') as HTMLDivElement;

    if (!chartElement) {
      console.error('Task Status chart element not found');
      return;
    }

    const year = this.getDwmYear(this.selectedGraphYear, this.selectedGraphMonth);
    const month = this.selectedGraphMonth;

    const title = this.isTeamView ? `Team Task Status - ${month} ${year}` : `My Task Status - ${month} ${year}`;

    this.downloadGraphAsPDF(chartElement, title);
  }

  // ---------------------- Download complaince score graph ----------------------------
  downloadDashboardGraphForCompliancePDF() {
    const chartElement = document.getElementById('complianceScore') as HTMLDivElement;

    if (!chartElement) {
      console.error('Compliance Score chart element not found');
      return;
    }

    const year = this.getDwmYear(this.selectedGraphYearForCompliance, this.selectedGraphMonthForCompliance);
    const month = this.selectedGraphMonthForCompliance;

    const title = this.isTeamView ? `Team Compliance Score Trend - ${month} ${year}` : `My Compliance Score Trend - ${month} ${year}`;

    this.downloadGraphAsPDF(chartElement, title);
  }

  // --------------------------- Download graph for critical task -----------------------------
  downloadCriticalTaskPDF() {
    const tableElement = document.getElementById('criticalTasksTable') as HTMLDivElement;

    if (!tableElement) {
      console.error('Critical Tasks table not found');
      return;
    }

    const year = this.getDwmYear(this.selectedGraphYearForCritical, this.selectedGraphMonthForCritical);
    const month = this.selectedGraphMonthForCritical;

    const title = `Critical Tasks - ${month} ${year}`;
    this.downloadGraphAsPDF(tableElement, title);
  }

  //  ------------------------- Download graph for Incomplete task -----------------------
  downloadIncompleteTasksPDF() {
    const tableElement = document.getElementById('incompleteTasksTable') as HTMLDivElement;

    if (!tableElement) {
      console.error('Incomplete Tasks table not found');
      return;
    }

    const year = this.getDwmYear(this.selectedGraphYearForIncomplete, this.selectedGraphMonthForIncomplete);
    const month = this.selectedGraphMonthForIncomplete;

    const title = this.isTeamView ? `Team Incomplete Tasks - ${month} ${year}` : `My Incomplete Tasks - ${month} ${year}`;

    this.downloadGraphAsPDF(tableElement, title);
  }

  downloadGraphAsPDF(chartHTMLDivElement: HTMLDivElement, title: string) {
    if (!chartHTMLDivElement) return;

    const scaleFactor = 3; // Increase the scale factor for better quality (e.g., 2 for HD)

    html2canvas(chartHTMLDivElement, { scale: scaleFactor }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();

      // Get the current date and year
      const currentDate = new Date();
      const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

      // Add Title at the top
      pdf.setFontSize(16);
      pdf.text(title, 105, 10, { align: 'center' });

      // Add the current date and year below the title
      pdf.setFontSize(12);

      // Add chart image below the text
      const imgWidth = 190; // Adjust width
      const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
      pdf.addImage(imgData, 'PNG', 10, 25, imgWidth, imgHeight);

      // Save the PDF
      pdf.save(`${title}-${todayDate}.pdf`);
    });
  }

  // --------------------------------------------- Download graph for the product alloaction--------------------------------
  downloadProductAllocationPDF() {
    const chartElement = document.getElementById('productAllocation') as HTMLDivElement;

    if (!chartElement) {
      console.error('Product Allocation chart element not found');
      return;
    }

    const year = this.getDwmYear(this.selectedGraphYearForProduct, this.selectedGraphMonthForProduct);
    const month = this.selectedGraphMonthForProduct;

    const title = this.isTeamView ? `Team Product Allocation - ${month} ${year}` : `My Product Allocation - ${month} ${year}`;

    this.downloadGraphAsPDF(chartElement, title);
  }

  getEffectiveUserId() {
    if (this.isTeamView) {
      return null; // IMPORTANT → do NOT send userId
    }
    return this.loggedInUserId;
  }

  // -------------------------------------- Incomplete Tasks from Previous Periods --------------------------------------------


  onIncompleteTaskYearChange(year: any) {
    this.selectedGraphYearForIncomplete = year;
    this.selectedGraphMonthForIncomplete = '';
    this.incompleteTaskList = [];
    this.selectedGraphMonthForIncomplete && this.getDashboardIncompleteTask();

    this.getDashboardIncompleteTask();
    if (year === this.selectedYearForDWM) {
      this.selectedGraphMonthForIncomplete = this.selectedMonthForDWM;
      this.getDashboardIncompleteTask();
    }

  }

  onIncompleteTaskMonthChange(month: any) {
    this.selectedGraphMonthForIncomplete = month;
    this.getDashboardIncompleteTask();


  }


  incompleteTaskList: any[] = [];
  teamIncompleteTaskList: any[] = []; // for team view

  getDashboardIncompleteTask() {
    if (!this.selectedGraphYearForIncomplete || !this.selectedGraphMonthForIncomplete) return;
    this.incompleteTaskList = [];

    const monthNumber = this.monthsList.indexOf(this.selectedGraphMonthForIncomplete) + 1;

    // Payload: decide userId or managerId based on toggle
    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(this.selectedGraphYearForIncomplete, this.selectedGraphMonthForIncomplete),
      month: monthNumber
    };

    if (this.isTeamView) {
      payload.managerId = this.loggedInUserId;
    } else {
      payload.userId = this.loggedInUserId;
    }

    this.httpService.callPostService(this.config.getDwmIncompleteTaskPreviousPeriod, payload).subscribe((res: any) => {
      if (res?.status && res?.data?.tasks?.length) {
        this.incompleteTaskList = res.data.tasks;
      } else {
        this.incompleteTaskList = [];
      }
    });
  }

  // -------------------------------------------------------- Product Time Allocation (Bar Chart) - R&D EMPLOYEE Only -----------------------------------------------
  // onProductAllocationYearChange(year: any) {
  // this.selectedGraphYearForProduct = year;
  // this.selectedGraphMonthForProduct = '';
  // this.selectedGraphMonthForProduct && this.getBarChartForProductTimeForRnDUser();

  //   //  this.initProductAllocationChart();    
  //    if (year === this.selectedYearForDWM) {
  //     this.selectedGraphMonthForProduct = this.selectedMonthForDWM;
  //     this.getBarChartForProductTimeForRnDUser();
  //   }
  // }

  onProductAllocationYearChange(year: any) {
    this.selectedGraphYearForProduct = year;

    // RESET OLD DATA FIRST (important for UI reset)
    this.selectedGraphMonthForProduct = '';
    this.productAllocationBarData = [];

    // If same year as DWM → auto pick default month
    if (year === this.selectedYearForDWM) {
      this.selectedGraphMonthForProduct = this.selectedMonthForDWM;
    }

    // Call API ONLY if month exists
    if (this.selectedGraphMonthForProduct) {
      this.getBarChartForProductTimeForRnDUser();
    } else {
      // Optional: clear chart properly
      this.productAllocationChartOption =
        this.getBarGraphOptionForProductAllocation([]);
      this.initProductAllocationChart();
    }
  }

  onProductAllocationMonthChange(month: any) {
    this.selectedGraphMonthForProduct = month;
    this.getBarChartForProductTimeForRnDUser();
  }



  get showRndGraph(): boolean {
    const isManagerOrHod = this.loggedInUserRole === 'HOD' || this.loggedInUserRole === 'Manager';

    // If Manager/HOD login AND team view is enabled → hide graph
    if (isManagerOrHod && this.isTeamView) {
      return false;
    }

    // Otherwise show only for RND employee
    return this.isRNDEmployee;
  }

  productAllocationBarData: any[] = [];

  getBarChartForProductTimeForRnDUser() {
    if (!this.selectedGraphYearForProduct || !this.selectedGraphMonthForProduct) {
      return;
    }

    const userId = this.getEffectiveUserId();
    if (!userId) return;

    const monthNumber = this.monthsList.indexOf(this.selectedGraphMonthForProduct) + 1;

    const payload = {
      userId,
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(this.selectedGraphYearForProduct, this.selectedGraphMonthForProduct),
      month: monthNumber
    };

    this.httpService.callPostService(this.config.getDashboardGraphForRnDUser, payload).subscribe((res: any) => {
      const apiData = res?.data || [];

      //  IMPORTANT: clear old data first
      this.productAllocationBarData = [];

      if (!apiData.length) {
        this.productAllocationChartOption = this.getBarGraphOptionForProductAllocation([]);
        this.initProductAllocationChart();
        return;
      }

      this.productAllocationBarData = apiData.map((item: any) => ({
        name: item.productName,
        value: item.noOfTask,
        workedHours: item.workedHours
      }));

      this.productAllocationChartOption = this.getBarGraphOptionForProductAllocation(this.productAllocationBarData);

      this.initProductAllocationChart();
    });
  }

  getBarGraphOptionForProductAllocation(data: any[]): echarts.EChartsOption {
    return {
      color: ['#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          const item = params[0];
          const extra = data[item.dataIndex];
          return `
          <b>${item.name}</b><br/>
          Tasks: ${item.value}<br/>
          Worked Hours: ${extra.workedHours}
        `;
        }
      },
      xAxis: {
        type: 'category',
        data: data.map(d => d.name),
        axisLabel: {
          formatter: (value: string) => value.split(' ').join('\n')
        }
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false }
      },
      series: [
        {
          type: 'bar',
          data: data.map(d => d.value),
          barWidth: '20%',
          label: {
            show: true,
            position: 'top',
            fontSize: 9
          }
        }
      ],
      grid: {
        top: '15%',
        left: '1%',
        right: '0%',
        bottom: '10%',
        containLabel: true
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: { show: false }
        },
        iconStyle: { borderColor: '#F3820E' }
      }
    };
  }

  productAllocationChartOption!: echarts.EChartsOption;
  productAllocationChartInstance!: echarts.ECharts;
  initProductAllocationChart() {
    const chartDom = document.getElementById('productAllocation')!;
    setTimeout(() => {
      if (!chartDom) return;
      if (this.productAllocationChartInstance) {
        this.productAllocationChartInstance.dispose();
      }

      this.productAllocationChartInstance = echarts.init(chartDom);
      this.productAllocationChartInstance.setOption(this.productAllocationChartOption);
      this.mobileResponsiveService.chartResizeFn(this.productAllocationChartInstance);
    }, 800);
  }

  // ---------------------- Critical Tasks ----------------------------------------

  onCriticalTaskYearChange(year: any) {
    this.selectedGraphYearForCritical = year;
    this.selectedGraphMonthForCritical = '';
    this.criticalTaskList = [];
    this.selectedGraphMonthForCritical && this.getDashboardForCriticalTask();

    this.getDashboardForCriticalTask();
    if (year === this.selectedYearForDWM) {
      this.selectedGraphMonthForCritical = this.selectedMonthForDWM;
      this.getDashboardForCriticalTask();
    }

  }

  onCriticalTaskMonthChange(month: any) {
    this.selectedGraphMonthForCritical = month;

    this.getDashboardForCriticalTask();


  }
  criticalTaskList: any[] = [];
  teamCriticalTaskList: any[] = []; // for team view

  get activeCriticalTaskList(): any[] {
    return this.isTeamView ? this.teamCriticalTaskList : this.criticalTaskList;
  }

  getDashboardForCriticalTask() {
    if (!this.selectedGraphYearForCritical || !this.selectedGraphMonthForCritical) return;

    const monthNumber = this.monthsList.indexOf(this.selectedGraphMonthForCritical) + 1;

    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(this.selectedGraphYearForCritical, this.selectedGraphMonthForCritical),
      month: monthNumber
    };

    if (this.isTeamView) {
      payload.managerId = this.loggedInUserId;
    } else {
      payload.userId = this.loggedInUserId;
    }


    this.httpService.callPostService(this.config.getDashboardGraphForCriticalTask, payload).subscribe((res: any) => {
      const tasks = res?.data || [];

      // Filter tasks for selected month
      const filteredTasks = tasks.filter((task: any) => {
        const taskMonth = new Date(task.dueDate).getMonth() + 1;
        const taskYear = new Date(task.dueDate).getFullYear();
        return taskMonth === monthNumber && taskYear === payload.year;
      });

      if (this.isTeamView) {
        this.teamCriticalTaskList = filteredTasks;
      } else {
        this.criticalTaskList = filteredTasks;
      }
    });
  }

  // ------------------------------------------- Compliance Score Graph-------------------------------------
  onComplianceYearChange(year: any) {
    this.selectedGraphYearForCompliance = year;
    this.selectedGraphMonthForCompliance = '';
    this.selectedGraphMonthForCompliance && this.getDashboardForComplianceScore();

    this.resetComplianceChart();
    if (year === this.selectedYearForDWM) {
      this.selectedGraphMonthForCompliance = this.selectedMonthForDWM;
      this.getDashboardForComplianceScore();
    }

  }

  onComplianceMonthChange(month: any) {
    this.selectedGraphMonthForCompliance = month;
    this.getDashboardForComplianceScore();
  }


  buildFullMonthXAxis(year: number, month: number): number[] {
    const totalDays = new Date(year, month, 0).getDate(); // month is 1-based
    return Array.from({ length: totalDays }, (_, i) => i + 1);
  }

  complianceChart!: echarts.ECharts;
  // Store team compliance lines for multi-line chart
  teamComplianceScoreLines: any[] = [];

  getDashboardForComplianceScore() {
    if (!this.selectedGraphYearForCompliance || !this.selectedGraphMonthForCompliance) return;

    const monthNumber = this.monthsList.indexOf(this.selectedGraphMonthForCompliance) + 1;

    const payload: any = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(this.selectedGraphYearForCompliance, this.selectedGraphMonthForCompliance),
      month: monthNumber
    };

    if (this.isTeamView) {
      payload.managerId = this.loggedInUserId; // team view: manager ID
    } else {
      payload.userId = this.loggedInUserId; // self view
    }

    this.httpService.callPostService(this.config.getDashboardGraphForComplianceScore, payload).subscribe((res: any) => {
      const lines = res?.data?.lines || [];

      if (!lines.length) {
        this.resetComplianceChart();
        return;
      }

      if (this.isTeamView) {
        // TEAM → Multi-Line Chart
        this.teamComplianceScoreLines = lines;
        this.renderTeamComplianceScoreChart(lines);

      } else {
        // SELF 

        const dataPoints = lines[0]?.dataPoints || [];

        const year = this.getDwmYear(this.selectedGraphYearForCompliance, this.selectedGraphMonthForCompliance);
        const fullXAxis = this.buildFullMonthXAxis(year, monthNumber);

        // map backend values by date
        const dateMap = new Map<number, number>();
        dataPoints.forEach((d: any) => {
          dateMap.set(d.xvalue, d.compliancePercentage);
        });

        const xAxisData = fullXAxis;
        const yAxisData = fullXAxis.map(day => dateMap.get(day) ?? 0);

        const hasData = yAxisData.some((v: number) => v > 0);
        if (!hasData) {
          this.resetComplianceChart();
          return;
        }

        this.renderComplianceScoreChart(xAxisData, yAxisData, hasData);
      }
    });
  }

  resetComplianceChart() {
    const chartDom = document.getElementById('complianceScore');
    if (!chartDom) return;

    if (!this.complianceChart) {
      this.complianceChart = echarts.init(chartDom);
    }

    // Empty / No-data state
    this.complianceChart.setOption(
      {
        title: {
          text: 'No data available',
          left: 'center',
          top: 'middle',
          textStyle: {
            color: '#9e9e9e',
            fontSize: 16
          }
        },
        xAxis: { show: false },
        yAxis: { show: false },

        series: []
      },
      true
    );

    setTimeout(() => {
      this.teamComplianceScoreLines = [];
      this.mobileResponsiveService.chartResizeFn(this.complianceChart);
    }, 500);

    // Clear team cache also
  }

  // renderTeamComplianceScoreChart(lines: any[]) {
  //   // Example ECharts configuration
  //   const xAxisData = lines[0].dataPoints.map((d: any) => d.xvalue); // assume same X-axis for all

  //   const series = lines.map((line: any) => ({
  //     name: line.userName,
  //     type: 'line',
  //     data: line.dataPoints.map((d: any) => d.compliancePercentage),
  //     smooth: true
  //   }));

  //   const option = {
  //     tooltip: { trigger: 'axis' },
  //     legend: { data: lines.map(l => l.userName) },
  //     xAxis: { type: 'category', data: xAxisData },
  //     yAxis: { type: 'value', max: 100 },
  //     series
  //   };

  //   const chartDom = document.getElementById('complianceScore')!;
  //   const myChart = echarts.init(chartDom);
  //   myChart.setOption(option);
  // }

  renderTeamComplianceScoreChart(lines: any[]) {
    const monthNumber = this.monthsList.indexOf(this.selectedGraphMonthForCompliance) + 1;
    const year = this.getDwmYear(this.selectedGraphYearForCompliance, this.selectedGraphMonthForCompliance);

    const fullXAxis = this.buildFullMonthXAxis(year, monthNumber);

    const series = lines.map((line: any) => {
      const map = new Map<number, number>();
      line.dataPoints.forEach((d: any) => {
        map.set(d.xvalue, d.compliancePercentage);
      });

      return {
        name: line.userName,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 8,
        showAllSymbol: true,
        data: fullXAxis.map(day => map.get(day) ?? 0)
       
      };
    });

    const option = {
  
      tooltip: {
        trigger: 'item',
        formatter: (p: any) => {
          const value = typeof p.value === 'number' ? p.value.toFixed(2) + '%' : p.value;

          return `
      <b>Day ${p.name}</b><br/>
      <div style="display:flex; justify-content:space-between;">
        <span>${p.marker} ${p.seriesName}</span>
        <span><b>${value}</b></span>
      </div>
    `;
        }
      },
      legend: {
        type: 'scroll',
        data: lines.map(l => l.userName),
        top: 10
      },
      // tooltip: { trigger: 'axis', valueFormatter: (value: any) => (typeof value === 'number' ? value.toFixed(2) + '%' : value) },
      // legend: { data: lines.map(l => l.userName) },
      // xAxis: {
      //   type: 'category',
      //   data: fullXAxis,
      //   boundaryGap: false,
      //   axisLabel: {
      //     interval: 0,
      //     rotate: 0
      //   }
      // },
      xAxis: {
        type: 'category',
        data: fullXAxis,
        name: 'Day of Month',
        nameLocation: 'middle',
        nameGap: 30,
        axisLabel: {
          interval: 0,
          rotate: 0
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 40
        },
        {
          type: 'inside'
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Compliance Score (%)',
        nameLocation: 'middle',
        nameGap: 30,
        max: 100,
        splitLine: { show: false },
      },

      series
    };

    const chartDom = document.getElementById('complianceScore')!;
    this.complianceChart = this.complianceChart || echarts.init(chartDom);
    setTimeout(() => {
      this.complianceChart.setOption(option, true);
      this.mobileResponsiveService.chartResizeFn(this.complianceChart);
    }, 500);
  }

  renderComplianceScoreChart(xData: any[], yData: number[], hasData: boolean) {
    const chartDom = document.getElementById('complianceScore')!;
    this.complianceChart = this.complianceChart || echarts?.init(chartDom);

    const option: echarts.EChartsOption = hasData
      ? {
        tooltip: { trigger: 'axis', valueFormatter: (value: any) => (typeof value === 'number' ? value.toFixed(2) + '%' : value) },
        grid: { left: '8%', right: '5%', bottom: '12%' },
        xAxis: {
          type: 'category',
          data: xData,
          name: 'Day of Month',
          nameLocation: 'middle',
          nameGap: 30,
          boundaryGap: false,
          axisLabel: {
            interval: 0,
            rotate: 0
          }
        },
        yAxis: {
          type: 'value',
          name: 'Compliance Score (%)',
          nameLocation: 'middle',
          nameGap: 30,
          min: 0,
          max: 100,
          axisLabel: { formatter: (value: number) => value.toFixed(0) + '%' },
          splitLine: { show: false }
        },
        series: [
          {
            type: 'line',
            data: yData,
            smooth: true,
            symbol: 'circle',
            symbolSize: 8
          }
        ]
      }
      : {
        title: {
          text: 'No data available',
          left: 'center',
          top: 'middle',
          textStyle: {
            color: '#9e9e9e',
            fontSize: 16
          }
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: []
      };

    setTimeout(() => {
      this.complianceChart.setOption(option, true);
      this.mobileResponsiveService.chartResizeFn(this.complianceChart);
    }, 500);
  }

  isEmpty(value: any): boolean {
    return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0) || (typeof value === 'string' && value.trim() === '');
  }

  // Hr and Admin
  applyDataFilters(event: any, filterName: any, applyFilter: boolean = true) {
    setTimeout(() => {
      // console.log('admin111122.');
      if (this.isEmpty(this.selectedFilters.selectedDepartment) && this.isEmpty(this.selectedFilters.selectedGrade) && this.isEmpty(this.selectedFilters.selectedEmpId)) {
        // console.log(`selectedDepartment, selectedGrade, selectedEmpId - - - - - - - - ${this.selectedFilters.selectedDepartment}, ${this.selectedFilters.selectedGrade}, ${this.selectedFilters.selectedEmpId}`);
        // this.selectedFilters[filterName] = event;
        // } else {

        this.selectedFilters = {
          selectedEmpId: null,
          searchString: null,
          selectedDepartment: null,
          selectedGrade: null,
          selectedCriticality: null,
          selectedYear: this.getSelectedYear(),
          selectedMonth: this.genericService.getCurrentMonth()
        };
        // console.log('admin1111.');
        this.getCountersForAdmin(this.selectedMonthForDWM ? this.allEmpIdsForAdmin : '');
      }

      // if (filterName == 'selectedYear' || filterName == 'selectedDate') this.selectedFilters.selectedDepartment = null;
      if (!this.selectedFilters?.selectedDepartment?.length || filterName == 'selectedDepartment') this.getGrades(this.selectedFilters?.selectedDepartment);
      if (filterName == 'selectedGrade') this.onGradeChange(this.selectedFilters?.selectedGrade);
      if (filterName == 'selectedEmpId') this.getCountersForAdmin(event);
    }, 250);

    // this.generateData();
  }

  getSelectedYear() {
    return this.getCompanyAndUserData.convertFinancialYear(this.getCompanyAndUserData?.loggedInCompanyFiscalyear || '', 'yearTextToNumber', '_');
  }

  getCountersForAdmin(empList: any) {
    if (!this.userIsAdminTypes?.userIsAdmin) return;
    const isArrayEmpList = Array.isArray(empList);
    const userIds = isArrayEmpList ? empList : [empList];
    this.filteredDashboardCounters = [];
    this.applyDashboardCounterFilter();

    const year = this.getCompanyAndUserData.getYearAsPerSelectedFinancialYearAnddMonth(this.selectedYearForDWM, this.selectedMonthForDWM);

    const payload = {
      companyId: this.loggedInUserCompanyID,
      year: String(year),
      month: this.genericService.getCurrentMonthInNumber(this.selectedMonthForDWM),
      userIds: userIds
    };

    forkJoin({
      adminSubmittedTask: this.httpService.callPostService(this.config.adminSubmittedTask, payload),
      adminApprovedTask: this.httpService.callPostService(this.config.adminApprovedTask, payload),
      adminRnDDuration: this.httpService.callPostService(this.config.adminRnDDuration, payload),
      adminComplianceScore: this.httpService.callPostService(this.config.adminComplianceScore, payload)
    }).subscribe({
      next: (data: any) => {
        const filterdata: any[] = [];
        let submittedTasks = 0;

        if (data?.adminSubmittedTask?.status) {
          let submited = 0,
            total = 0;
          if (isArrayEmpList) {
            // submited = data?.adminSubmittedTask?.data?.submittedTaskResponses?.length;
            data?.adminSubmittedTask?.data?.submittedTaskResponses?.map((data: any) => {
              if (data?.submittedCount) submited++;
            });
            submittedTasks = submited;
            total = empList?.length;
          } else {
            // data?.adminSubmittedTask?.data?.submittedTaskResponses?.map((data: any) => { if (data?.status === 'Pending') submited++; });
            submited = data?.adminSubmittedTask?.data?.submittedTaskResponses[0]?.submittedCount || 0;
            total = userIds.length;
          }
          filterdata.push({
            counterName: 'DWM Submitted',
            totalCount: (submited || 0) + '/' + (total || 0),
            percentage: Number(data?.adminSubmittedTask?.data?.submittedPercentage)
          });
        }

        if (data?.adminApprovedTask?.status) {
          let submited = 0,
            total = 0;
          if (isArrayEmpList) {
            data?.adminApprovedTask?.data?.approvedTaskResponses?.map((data: any) => {
              if (data?.noOfApprovedTasks) submited++;
            });
            // total = data?.adminApprovedTask?.data?.approvedTaskResponses?.length;
            total = submittedTasks;
          } else {
            submited = data?.adminApprovedTask?.data?.approvedTaskResponses[0]?.noOfApprovedTasks;
            total = userIds.length;
          }

          filterdata.push({
            counterName: 'DWM Approved',
            totalCount: (submited || 0) + '/' + (total || 0),
            percentage: Number(data?.adminApprovedTask?.data?.approvedPercentage)
          });
        }

        if (data?.adminComplianceScore?.status) {
          filterdata.push({
            counterName: 'Avg Compliance Score',
            totalCount: data?.adminComplianceScore?.data?.averageComplianceScore?.toFixed(2) || '0.00'
          });
        }

        if (data?.adminRnDDuration?.status) {
          filterdata.push({
            counterName: 'Total R&D Hours Logged',
            totalCount: data?.adminRnDDuration?.data?.hrRnDTotalDurationCount ?? 0
          });
        }

        this.adminCounterData(filterdata);
      }
    });
  }

  adminCounterData(data: any[]) {
    this.filteredDashboardCounters.forEach((counter: any) => {
      const matched = data.find(d => d.counterName === counter.counterName);
      if (!matched) return;

      counter.totalCount = matched.totalCount ?? counter.totalCount;
      // console.log('Admin counter..', counter.totalCount);
      counter.percentage = matched.percentage ? Number(matched.percentage).toFixed(2) : counter.percentage;
    });
  }

  // Audit trail

  onClickAuditTrail() {
    const dialogRef = this.dialog.open(DwmaudittrailhrComponent, {
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }


  // -------------------------------------- PLant Location wise Task Status --------------------------------------------


  //  ------------------------------ Get Plants Location -------------------------------------
  plantDropdownSettings = {
    singleSelection: false,
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
    idField: 'id',
    textField: 'name'
  };

  plantList: any[] = [];
  selectedPlants: string[] = [];
  isInitialLoad = true;
  getPlantsLocation() {
    this.httpService.callGetService(`${this.config.getPlantList}?companyId=${this.loggedInUserCompanyID}`).subscribe((data: any) => {
      this.plantList = (data?.data || []).map((item: any) =>
        item.plantLocation);
      //  FIRST LOAD → set default
      if (this.isInitialLoad) {
        this.selectedPlantsForDashbaordCounter = [...this.plantList];
        this.selectedPlants = [...this.plantList];
        this.isInitialLoad = false;
      }

      //  YEAR CHANGE → DO NOTHING (keep it empty)

      this.isYearChanging = false;

      this.getDashboardForHr();
      this.getDashboardGraphForPlantLocationWiseTaskStatus();
    });

  }



  onPlantSelect() {
    this.getDashboardGraphForPlantLocationWiseTaskStatus();
  }


  onPlantDeselect() {
    this.getDashboardGraphForPlantLocationWiseTaskStatus();
  }

  onPlantSelectAll(items: any[]) {
    this.selectedPlants = items;
    this.getDashboardGraphForPlantLocationWiseTaskStatus();
  }

  onPlantDeSelectAll() {
    this.selectedPlants = [];
    this.getDashboardGraphForPlantLocationWiseTaskStatus();
  }



  //  ------------------------------ Get PLant Location wise task status graph -------------------------------------

  //   getDashboardGraphForPlantLocationWiseTaskStatus() {
  //   const payload = {
  //     companyId: this.loggedInUserCompanyID,
  //     year: this.getDwmYear(),
  //     month: this.monthsList.indexOf(this.selectedGraphMonth) + 1,
  //     plantLocations: this.selectedPlants.map((p: any) => p.id || p)
  //   };

  //   this.httpService.callPostService(this.config.getDashoardHRForPlantwiseTaskStatus, payload)
  //     .subscribe((res: any) => {
  //       this.departmentsList = (res?.data || []).map((item: string) => ({
  //         id: item,
  //         name: item
  //       }));

  //     });
  // }

  // getDashboardGraphForPlantLocationWiseTaskStatus() {
  //   const payload = {
  //     companyId: this.loggedInUserCompanyID,
  //     year: this.getDwmYear(),
  //     month: this.monthsList.indexOf(this.selectedGraphMonthForPlantLocation) + 1,
  //     plantLocations: this.selectedPlants.map((p: any) => p.id || p)
  //   };

  //   this.httpService
  //     .callPostService(this.config.getDashoardHRForPlantwiseTaskStatus, payload)
  //     .subscribe((res: any) => {
  //       const data = res?.data;
  //       if (!data) return;

  //       //  Split plant locations
  //       const plants = data.plantLocation?.split(',') || [];

  //       //  Prepare chart data (TEMP same data for each plant)
  //       const chartData = plants.map((plant: string) => ({
  //         plant,
  //         doneOnTime: data.totalTasksDoneOnTime || 0,
  //         delay: data.totalTasksDoneWithDelay || 0,
  //         incomplete: data.totalTasksIncompleteAfterDueDate || 0,
  //         notCompleted: data.totalTasksNotCompleted || 0,
  //         avgCompliance: data.averageComplianceScore || 0,
  //         totalApproved: data.totalApprovedTasks || 0,
  //         totalEmployees: data.noOfEmployees || 0
  //       }));

  //       this.renderPlantStackedChart(chartData);
  //     });
  // }


  getDashboardGraphForPlantLocationWiseTaskStatus() {
    if (!this.selectedGraphMonthForPlantLocation) {
      this.renderPlantStackedChart([]);
      return;
    }
    const payload = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(this.selectedGraphYearForPlantLocation, this.selectedGraphMonthForPlantLocation),
      month: this.monthsList.indexOf(this.selectedGraphMonthForPlantLocation) + 1,
      plantLocations: this.selectedPlants.map((p: any) => p.id || p)
    };

    this.httpService
      .callPostService(this.config.getDashoardHRForPlantwiseTaskStatus, payload)
      .subscribe((res: any) => {
        const responseData = res?.data;
        if (!responseData || !responseData.length) {
          this.renderPlantStackedChart([]);
          return;
        }


        const chartData = responseData.map((item: any) => ({
          plant: item.plantLocation,
          doneOnTime: item.totalTasksDoneOnTime || 0,
          delay: item.totalTasksDoneWithDelay || 0,
          incomplete: item.totalTasksIncompleteAfterDueDate || 0,
          notCompleted: item.totalTasksNotCompleted || 0,
          avgCompliance: item.averageComplianceScore || 0,
          totalApproved: item.totalApprovedTasks || 0,
          totalEmployees: item.noOfEmployees || 0
        }));

        this.renderPlantStackedChart(chartData);
      });
  }

  renderPlantStackedChart(data: any[]) {
    const chartDom = document.getElementById('plantTaskStatus');
    if (!chartDom) return;

    const chart = echarts.init(chartDom);

    const plants = data.map(d => d.plant);

    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        confine: true,
        formatter: (params: any) => {
          const index = params[0].dataIndex;
          const item = data[index];

          return `
          <div style="padding:8px">
            <b>Plant Location: ${item.plant}</b><br/>
            <b>No. of Employees: ${item.totalEmployees}</b><br/>
            <b>Total Approved Tasks: ${item.totalApproved}</b><br/>
             <span style="color:#209624," >●</span> Done on Time: <b>${item.doneOnTime}</b><br/>
            <span style="color:#FFC107">●</span> Done with Delay: <b>${item.delay}</b><br/>
            <span style="color:#5f5959">●</span> Incomplete After Due Date: <b>${item.incomplete}</b><br/>
            <span style="color:#ee1d0e">●</span> Not Completed: <b>${item.notCompleted}</b><br/>

            <b>Avg Compliance: ${item.avgCompliance}%</b>
          </div>
        `;
        }
      },
      legend: {
        bottom: 0
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '12%',
        containLabel: true
      },

      dataZoom: [
        {
          type: 'slider',
          show: true,
          xAxisIndex: 0,
          start: 0,
          end: 50,
          height: 20,
          bottom: 30
        },
        {
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 50
        }
      ],

      xAxis: {
        type: 'category',
        data: plants,
        name: 'Plant Location',
        nameLocation: 'middle',
        nameGap: 30,
      },
      yAxis: {
        type: 'value',
        name: 'Task Count',
        nameLocation: 'middle',
        nameGap: 50,
        axisLabel: {
          formatter: (value: number) => this.formatCount(value)
        },
        // name: 'Task Count',
        //    nameLocation: 'middle',
        //   nameGap: 50, 
        splitLine: {
          show: false
        }
      },
      series: [
        {
          name: 'Done on Time',
          type: 'bar',
          stack: 'total',
          itemStyle: { color: '#209624' },
          data: data.map(d => d.doneOnTime)
        },
        {
          name: 'Done with Delay',
          type: 'bar',
          stack: 'total',
          itemStyle: { color: '#FFC107' },
          data: data.map(d => d.delay)
        },
        {
          name: 'Incomplete After Due Date',
          type: 'bar',
          stack: 'total',
          itemStyle: { color: '#5f5959' },
          data: data.map(d => d.incomplete)
        },
        {
          name: 'Not Completed',
          type: 'bar',
          stack: 'total',
          itemStyle: { color: '#ee1d0e' },
          data: data.map(d => d.notCompleted),
          // label: {
          //   show: true,
          //   position: 'top',
          //   fontWeight: '600',
          //   formatter: (params: any) => {
          //     const index = params.dataIndex;
          //     return data[index].value;
          //   }
          // }
          label: {
            show: true,
            position: 'top',
            fontWeight: '600',
            formatter: (params: any) => {
              const index = params.dataIndex;
              const item = data[index];

              const total =
                item.doneOnTime +
                item.delay +
                item.incomplete +
                item.notCompleted;

              return this.formatCount(total); // optional formatting
            }
          }
        }
      ]
    };

    chart.setOption(option);
    this.mobileResponsiveService.chartResizeFn(chart);
  }


  //  values converter 1000 to 1K, 1000000 to 1M etc for better readability in charts
  formatCount(value: number): string {
    if (value == null) return '0';

    if (value >= 10000000) {
      return (value / 10000000).toFixed(1).replace(/\.0$/, '') + 'Cr'; // Crore
    } else if (value >= 100000) {
      return (value / 100000).toFixed(1).replace(/\.0$/, '') + 'L'; // Lakh
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'K'; // Thousand
    } else {
      return value.toString();
    }
  }
}
